import { render, staticRenderFns } from "./FooterModule.vue?vue&type=template&id=90b0dcca&"
import script from "./FooterModule.ts?vue&type=script&lang=ts&"
export * from "./FooterModule.ts?vue&type=script&lang=ts&"
import style0 from "./FooterModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports